/* tslint:disable */
/* eslint-disable */
/**
 * Vocabulary Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface VocabularyAsList
 */
export interface VocabularyAsList  {
    /**
     * 
     * @type {string}
     * @memberof VocabularyAsList
     */
    vocabulary?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VocabularyAsList
     */
    notations?: Array<string>;
}

/**
 * Check if a given object implements the VocabularyAsList interface.
 */
export function instanceOfVocabularyAsList(value: object): value is VocabularyAsList {
    return true;
}

export function VocabularyAsListFromJSON(json: any): VocabularyAsList {
    return VocabularyAsListFromJSONTyped(json, false);
}

export function VocabularyAsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): VocabularyAsList {
    if (json == null) {
        return json;
    }
    return {
        
                  'vocabulary': json['vocabulary'] == null ? undefined : json['vocabulary'],
              'notations': json['notations'] == null ? undefined : json['notations'],
    };
}

export function VocabularyAsListToJSON(json: any): VocabularyAsList {
    return VocabularyAsListToJSONTyped(json, false);
}

export function VocabularyAsListToJSONTyped(value?: VocabularyAsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'vocabulary': value['vocabulary'],
        'notations': value['notations'] == null? value['notations']: value['notations'],
    };
}


